import FullCalendar from "@fullcalendar/react";
import esLocale from "@fullcalendar/core/locales/es";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";

import "../../styles/calendar.scss";

const WeeklCalendarComponent = ({ calendarRef, events,handleEventEdit }) => {
  return (
    <div className="calendar-app-main week-app-main">
      <FullCalendar
        ref={calendarRef}
        plugins={[dayGridPlugin, interactionPlugin, timeGridPlugin]}
        headerToolbar={{
          left: "",
          center: "",
          right: "",
        }}
        locale={esLocale}
        initialView="dayGridWeek"
        events={events}
        eventTimeFormat={{
          hour: "2-digit",
          minute: "2-digit",
        }}
        // editable={true}
        selectable={true}
        allDaySlot={false}
        eventClick={handleEventEdit}
        dayMaxEvents={true}
        weekends={false}
        showNonCurrentDates={false}
      />
    </div>
  );
};

export default WeeklCalendarComponent;
